
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/finance",
      function () {
        return require("private-next-pages/finance.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/finance"])
      });
    }
  